import { updateArrayItem } from '@/util/array';
import countriesService from '@/api/countries-service';
import eventBus, { OPEN_SNACKBAR } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';

const state = {
  countries: null,
  countriesFilterParams: {},
};

const getters = {
  countriesMap(state) {
    const map = {};
    if (!state.countries) {
      return {};
    }
    for (let i = 0; i < state.countries?.length; i++) {
      const title = state.countries[i][`title_${i18n.locale}`];
      map[state.countries[i].code] = { title };
    }
    return map;
  },

  filteredCountries(state) {
    if (!state.countries) {
      return [];
    }

    let countries = [...state.countries];

    if (state.countriesFilterParams?.is_visible) {
      countries = countries.filter((country) => country.is_visible);
    }

    if (state.countriesFilterParams?.search) {
      const transformedSearch = state.countriesFilterParams.search.toLowerCase().trim();
      countries = countries.filter(
        (country) =>
          // eslint-disable-next-line implicit-arrow-linebreak
          country[`title_${i18n.locale}`].toLowerCase().includes(transformedSearch) ||
          country.code.toLowerCase().includes(transformedSearch),
      );
    }
    return countries;
  },

  localizedCountries(state) {
    if (!state.countries) {
      return [];
    }
    const localizedCountries = [];
    for (let i = 0; i < state.countries.length; i++) {
      if (state.countries[i].code === 'lt') {
        localizedCountries.unshift(state.countries[i]);
      } else {
        localizedCountries.push(state.countries[i]);
      }
    }

    return localizedCountries
      .filter((country) => country.is_visible)
      .map((country) => ({
        id: country.id,
        title: country[`title_${i18n.locale}`],
        code: country.code,
      }));
  },
};

const mutations = {
  SET_COUNTRIES(state, data) {
    state.countries = data;
  },

  SET_FILTER_PARAMS(state, params) {
    const transformedParams = { ...params };
    if (params.is_visible === 'true') {
      transformedParams.is_visible = true;
    }
    state.countriesFilterParams = transformedParams;
  },

  UPDATE_COUNTRY(state, country) {
    state.countries = updateArrayItem(state.countries, country);
  },
};

const actions = {
  fetchCountries({ state, commit }, params = {}) {
    commit('SET_FILTER_PARAMS', params);
    if (state.countries) {
      return Promise.resolve(state.countries);
    }
    return countriesService.getPage().then((res) => {
      commit('SET_COUNTRIES', res.data);
      return res.data;
    });
  },

  updateCountry({ commit }, country) {
    return countriesService
      .update(country)
      .then((res) => {
        commit('UPDATE_COUNTRY', res.data);
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('country_updated'));
      })
      .catch((err) => {
        throw err;
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
